import React, { useCallback, useEffect, useState } from "react";
import SkeletonLoader from "../../Component/skeleton-loader/Skeleton";
import { BUSINESS_ADS, DAILY_DEAL } from "../../Utils/constants";
import { getAds, getDailyDeals } from "../../API/ApiService";
import { useDispatch, useSelector } from "react-redux";
import { skeletonAction } from "../../Redux/Action/loadingAction";
import EmptyMessage from "../../Component/EmptyMessage";
import DailyDealsAds from "../../Component/DailyDealsAds";
import styled from "styled-components";
import DailyDealsCard from "../../Component/DailyDealsCard";
import { useNavigate } from "react-router";
import Card from "../../Component/Card";
import InfiniteScroll from "react-infinite-scroll-component";

function DailyDeals() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    latLng: { lat, lng },
  } = useSelector((state) => state.locationReducer);

  const adIsLoading = useSelector(
    (state) => state?.loadingReducers?.skeletonLoader?.BUSINESS_ADS
  );
  const skeletonLoad = useSelector(
    (state) => state?.loadingReducers?.skeletonLoader
  );
  const { stateList, selectedState } = useSelector(
    (state) => state.locationReducer
  );

  const currentState = stateList.find((s) => s.state_code === selectedState);
  const [adsList, setAdsList] = useState([]);
  const [daliyDealsList, setDailyDeals] = useState([]);
  const [isNext, isNextFunc] = useState(false);
  const [pageCount, setCount] = useState(1);
  const user_uuid = localStorage.getItem("user_uuid");

  const businessPage = (id, b_name) => {
    navigate(
      `/businessDetails/${id}?name=${b_name?.trim()?.replaceAll(" ", "_")}`,
      { state: { id } }
    );
  };

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 400);
    };
  };


  const fetchData = useCallback(
    async () => {
      const body = {
        page: pageCount,
        text: "",
        fetchtype: "seeall",
        user_uuid: user_uuid,
        limit: 10,
        state: currentState?.state || "",
        state_code: currentState?.state_code || "",
        lat,
        lng,
        user_uuid: user_uuid
      };

      dispatch(skeletonAction(true, DAILY_DEAL));
      if ((body.lat && body.lng) || body.state.length > 0) {
        getDailyDeals(body)
          .then((res) => {
            if(res.data.result){
              if (pageCount === 1) {
                setDailyDeals([...res.data.result.BusinessList]);
              } else {
                setDailyDeals([...daliyDealsList, ...res.data.result.BusinessList]);
              }
            }
            dispatch(skeletonAction(false, DAILY_DEAL));
            const totalPageCount = Math.ceil(
              res.data.result?.TotalRecords / 10
            );
            isNextFunc(pageCount !== totalPageCount && res.data.result.BusinessList.length === 10);
          })
          .catch(() => {
            dispatch(skeletonAction(false, DAILY_DEAL));
          });
      }
    },
    [lat, lng, currentState, pageCount]
  );


  useEffect(() => {
    async function fetchAds() {
      dispatch(skeletonAction(true, BUSINESS_ADS));
      await getAds({ lat, lng })
        .then((res) => {
          setAdsList(res.data.result);
          dispatch(skeletonAction(false, BUSINESS_ADS));
        })
        .catch(() => {
          dispatch(skeletonAction(false, BUSINESS_ADS));
        });
    }

    if (lat && lng) {
      fetchAds();
    }
  }, [lat, lng]);

  // Fetch daily deals data from API
  // useEffect(() => {
  //   const body = {
  //     page: 1,
  //     text: "",
  //     fetchtype: "home",
  //     user_uuid: user_uuid,
  //     limit: 100,
  //     state: currentState?.state || "",
  //     state_code: currentState?.state_code || "",
  //     lat,
  //     lng,
  //   };

  //   dispatch(skeletonAction(true, DAILY_DEAL));
  //   if ((body.lat && body.lng) || body.state.length > 0) {
  //     getDailyDeals(body)
  //       .then((res) => {
  //         setDailyDeals(res.data.result);
  //         dispatch(skeletonAction(false, DAILY_DEAL));
  //       })
  //       .catch(() => {
  //         dispatch(skeletonAction(false, DAILY_DEAL));
  //       });
  //   }
  // }, [currentState, lat, lng]);

  const fetchMoreData = () => {
    setCount(pageCount + 1);
  };


  const debouncVersion = useCallback(debounce(fetchData), [
    lat,
    lng,
    currentState,
    pageCount,
  ]);

  useEffect(() => {
    debouncVersion();
  }, [pageCount]);

  useEffect(() => {
    if (pageCount === 1) {
      debouncVersion();
    } else {
      setCount(1);
    }
  }, [lat, lng, currentState]);

  console.log(lat);

  const renderCombinedContent = () => {
    const ads = adsList?.basic || [];

    const deals = daliyDealsList || [];
    const combinedContent = [];
    let dealIndex = 0;

    // Function to add two deals
    const addTwoDeals = () => {
      const dealsRow = [];
      for (let i = 0; i < 2 && dealIndex < deals.length; i++) {
        dealsRow.push(
          <div
            className={`col-md-6 ${i === 0 ? "" : ""}`}
            key={`deal_${dealIndex}`}
            style={{
              marginBottom: "20px",
              marginTop: "20px",
              // padding: i === 0 ? "12px" : "12px",
            }}
          >
            <Card
              width="100%"
              height="100%"
              data={deals[dealIndex]}
              showReview
              showAddress
              showPhone
              handleViewDetail={businessPage}
               cardIndex={dealIndex}
            />
          </div>
        );
        dealIndex++;
      }

      if (dealsRow.length > 0) {
        combinedContent.push(
          <div
            className="row"
            key={`deals_row_${dealIndex}`}
            style={{
              marginBottom: "10px",
              marginLeft: "0px",
              marginRight: "0px",
            }}
          >
            {dealsRow}
          </div>
        );
      }
    };

    // First, add ads with two deals after each
    for (let adIndex = 0; adIndex < ads.length; adIndex++) {
      // Add the ad
      combinedContent.push(
        <div className="row" key={`ad_${adIndex}`}>
          <div className="col-12">
            <DailyDealsAds
              width="100%"
              height={"100%"}
              data={ads[adIndex]}
              showReview
              showAddress
              showPhone
              handleViewDetail={businessPage}
              padding={"10px"}
            />
          </div>
        </div>
      );

      // Add two deals after the ad
      if (dealIndex < deals.length) {
        addTwoDeals();
      }
    }

    // Add remaining deals in pairs of two
    while (dealIndex < deals.length) {
      addTwoDeals();
    }

    return combinedContent;
  };

  return (
    <>
      <div>
        <section className="interestDiv">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>
                  Daily <span style={{ color: "#3CA059" }}>Deals</span>
                </h2>
              </div>
            </div>

            {adIsLoading || skeletonLoad[DAILY_DEAL] ? (
              <LoadingBlocks>
                {Array.from({ length: 3 }, (_, index) => (
                  <div
                    key={`skeleton_${index}`}
                    className="slider-skeleton-block"
                  >
                    <SkeletonLoader height={360} />
                  </div>
                ))}
              </LoadingBlocks>
            ) : !adsList?.basic?.length &&
              !daliyDealsList?.BusinessList?.length ? (
              <EmptyMessage message="No content available." />
            ) : (
              <InfiniteScroll
                dataLength={daliyDealsList.length}
                next={fetchMoreData}
                hasMore={isNext}
              >
                <div className="container mt-4">{renderCombinedContent()}</div>
              </InfiniteScroll>
            )}
          </div>
        </section>
      </div>
    </>
  );
}

export default DailyDeals;

const LoadingBlocks = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding: 20px;

  .slider-skeleton-block {
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
  }
`;
